import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import { Colors } from '../../theme'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import FilterDropdownMenu from '../../controls/FilterDropdownMenu'
import RBButton from '../../controls/RBButton'
import RBDatePicker from '../../controls/RBDatePicker'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  fetchUnclaimedHCSAExpenses,
  setFilters,
  changePage
} from '../../redux/actions/submitExpenseActions'
import moment from 'moment'
import { localize } from '../../util/Localizer'
import { formatCurrency } from '../../util/CurrencyFormatter'
import Tooltip from '../../controls/Tooltip'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import Config from '../../Config'

class hcsaFilter extends Component {
  constructor () {
    super()
    this.updateFilters = this.updateFilters.bind(this)
    this.filterClaims = this.filterClaims.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
    this.showFilterBar = this.showFilterBar.bind(this)
    this.updateDropdowns = this.updateDropdowns.bind(this)
    this.rememberFilters = this.rememberFilters.bind(this)
    this.defaultFilter = {
      name: 'All',
      type: 'All',
      startPeriod: null,
      endPeriod: null
    }
    this.state = {
      collapseFilterBar: false,
      filters: JSON.parse(JSON.stringify(this.defaultFilter))
    }
  }

  componentDidMount () {
    this.updateDropdowns()
    this.rememberFilters()
  }

  componentDidUpdate (prevProps) {
    if (this.props.name === 'clear') {
      this.clearFilters()
    }
  }

  updateFilters (valueObj) {
    const filters = this.state.filters
    const updatedFilters = Object.assign(filters, valueObj)
    this.setState({ filters: updatedFilters })
  }
  rememberFilters () {
    if (this.props.filterObj) {
      const filtersCopy = this.props.filterObj
      this.setState({ filters: filtersCopy }, () => { return this.state.filters })
    }
  }
  updateDropdowns () {
    if (this.props.dropdowns) {
      let dropdowns = this.props.dropdowns
      const members = dropdowns.patient.filter((patient) => patient.id !== 0).map(patient => { return { id: patient.id, text: patient.label } })
      const benefits = dropdowns.benefits.filter((benefit) => benefit.id !== 0).map(benefit => { return { id: benefit.id, text: benefit.label } })
      this.setState({
        dropdowns: {
          members,
          benefits
        }
      })
    }
  }

  clearFilters () {
    this.membersDropdown.resetState()
    this.benefitsDropdown.resetState()

    let newState = { filters: JSON.parse(JSON.stringify(this.defaultFilter)) }

    this.setState(newState)
    this.props.setFilters(newState)
    this.props.changePage(1)
  }

  filterClaims () {
    const filterCard = document.getElementById('filterCard')

    if (filterCard.classList.contains('showFilter')) {
      this.setState({ collapseFilterBar: !this.state.collapseFilterBar })
      filterCard.classList.toggle('showFilter')
    }

    const {
      name,
      type,
      startPeriod,
      endPeriod
    } = this.state.filters

    let obj = {
      name,
      type,
      startDate: startPeriod ? moment(startPeriod).startOf('day').format() : undefined,
      endDate: endPeriod ? moment(endPeriod).endOf('day').format() : undefined,
      pageNum: 1
    }

    this.props.setFilters(obj)
  }

  showFilterBar () {
    this.setState({ collapseFilterBar: !this.state.collapseFilterBar })
    const filterCard = document.getElementById('filterCard')
    filterCard.classList.toggle('showFilter')
  }

  renderPeriodTotals () {
    const { hcsaExpenseData, prevPeriodTotal, currPeriodTotal } = this.props
    const ultimateTotal = Number(prevPeriodTotal) + Number(currPeriodTotal)
    const dateFormat = Config.dateFormat

    return (
      <div className='hcsaPeriodTotals'>
        <Row start='xs' style={{ paddingLeft: '1.1rem' }}>
          {hcsaExpenseData && hcsaExpenseData.pastYearPeriod
            ? <Row className='hcsaFilterRow'>
              <Col>
                <Row>
                  <p className='hcsaFilterTitle'>{`${localize('pages.SubmitAClaim.Expenses.previousPeriod')}:`}</p>
                  <Tooltip title={`${moment(hcsaExpenseData.pastYearPeriod.benefitPeriodStart).format(dateFormat)} to ${moment(hcsaExpenseData.pastYearPeriod.benefitPeriodEnd).format(dateFormat)}`} placement="top">
                    <IconButton tabIndex={-1} className='hcsaToolTip' size='small'>
                      <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                    </IconButton>
                  </Tooltip>
                </Row>
              </Col>
              <Col>
                <p className='hcsaFilterSubTitle'>
                  {formatCurrency(hcsaExpenseData.pastYearPeriod.benefitPeriodFunds || 0).replace('CA', '')}
                  <span style={{ color: Colors.Palette.primaryColor }}>
                    {(prevPeriodTotal > 0) ? `  - ${formatCurrency(prevPeriodTotal || 0).replace('CA', '')}` : null}
                  </span>
                </p>
              </Col>
            </Row> : null}
          {hcsaExpenseData && hcsaExpenseData.currentYearPeriod
            ? <Row className='hcsaFilterRow'>
              <Col>
                <Row>
                  <p className='hcsaFilterTitle'>{`${localize('pages.SubmitAClaim.Expenses.currentPeriod')}:`}</p>
                  <Tooltip title={`${moment(hcsaExpenseData.currentYearPeriod.benefitPeriodStart).format(dateFormat)} to ${moment(hcsaExpenseData.currentYearPeriod.benefitPeriodEnd).format(dateFormat)}`} placement="top">
                    <IconButton tabIndex={-1} className='hcsaToolTip' size='small'>
                      <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                    </IconButton>
                  </Tooltip>
                </Row>
              </Col>
              <Col>
                <p className='hcsaFilterSubTitle'>
                  {formatCurrency(hcsaExpenseData.currentYearPeriod.benefitPeriodFunds || 0).replace('CA', '')}
                  <span style={{ color: Colors.Palette.primaryColor }}>
                    {(currPeriodTotal > 0) ? `  - ${formatCurrency(currPeriodTotal || 0).replace('CA', '')}` : null}
                  </span>
                </p>
              </Col>
            </Row> : null}
          {hcsaExpenseData
            ? <Row className='hcsaFilterRow'>
              <Col>
                <p className='hcsaFilterTitle'>{`${localize('pages.SubmitAClaim.Expenses.Total')}:`}</p>
              </Col>
              <Col>
                <p className='hcsaFilterSubTitle'>{formatCurrency(ultimateTotal || 0).replace('CA', '')}</p>
              </Col>
            </Row> : null}
        </Row>
      </div>
    )
  }

  render () {
    const { classes = {} } = this.props
    const dateInputProps = {
      style: {
        fontSize: '0.77rem',
        lineHeight: '1.1875rem'
      }
    }

    return (
      <div id={'filterComponent'}>
        <Card id='smallFilterCard' className={classes.baseCard}>
          <Row between='xs' middle='xs'>
            <Col xsOffset={1} xs={6} sm={8} md={8}>
              {this.renderPeriodTotals()}
            </Col>
            <Col >
              <RBButton
                label={localize('pages.claims.filter.filterClaims')}
                labelPosition='before'
                color
                icon={<Icon color='primary'>filter_list</Icon>}
                onClick={this.showFilterBar} />
            </Col>
          </Row>
        </Card>
        <Card id='filterCard' >
          <Grid fluid>
            <Row className='filterBar' middle='xs'>
              <Col lg={10} lgOffset={1} className='filterControls'>
                <Row style={{ display: 'flex', alignItems: 'center' }}>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <FilterDropdownMenu ref={(comp) => { this.membersDropdown = comp }}
                      fullWidth
                      data={this.props.members}
                      id='name'
                      defaultText={localize('pages.claims.filter.members.placeholder')}
                      label={localize('pages.claims.filter.members.label')}
                      sendValues={this.updateFilters}
                      disabled={this.props.isLoading}
                      selected={this.state.filters.name || this.props.name} />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <FilterDropdownMenu ref={(comp) => { this.benefitsDropdown = comp }}
                      fullWidth
                      data={this.props.benefits}
                      id='type'
                      defaultText={localize('pages.claims.filter.benefits.placeholder')}
                      label={localize('pages.claims.filter.benefits.label')}
                      sendValues={this.updateFilters}
                      disabled={this.props.isLoading}
                      selected={this.state.filters.type || this.props.type} />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard'>
                    <RBDatePicker ref={(comp) => { this.startPeriodpicker = comp }}
                      id='startDate'
                      label={localize('pages.claims.filter.startPeriod.label')}
                      fullWidth
                      pickerProps={{
                        InputProps: dateInputProps,
                        autoOk: true,
                        maxDate: moment(),
                        disabled: this.props.isLoading,
                        value: this.state.filters.startPeriod || null,
                        onChange: (startPeriod) => this.updateFilters({ startPeriod })
                      }}
                    />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard' >
                    <RBDatePicker ref={(comp) => { this.endPeriodpicker = comp }}
                      id='endPeriod'
                      label={localize('pages.claims.filter.endPeriod.label')}
                      fullWidth
                      pickerProps={{
                        InputProps: dateInputProps,
                        autoOk: true,
                        maxDate: moment(),
                        disabled: this.props.isLoading,
                        value: this.state.filters.endPeriod || null,
                        onChange: (endPeriod) => this.updateFilters({ endPeriod })
                      }}
                    />
                  </Col>
                  <Col {...Columns.max6} className='ieFilterCard' smOffset={2} xs={12}>
                    <br />
                    <Row center='xs' middle='xs' >
                      <Col>
                        <div >
                          <RBButton id='applyFilter'
                            variant='outlined'
                            color
                            label={localize('pages.claims.filter.apply')}
                            onClick={this.filterClaims}
                            disabled={this.props.isLoading} />
                        </div>
                        <RBButton
                          styles={{ margin: 5 }}
                          role='button'
                          label={localize('pages.claims.filter.clear')}
                          aria-label={localize('pages.claims.filter.clear')}
                          onClick={this.clearFilters}
                          color
                          disabled={this.props.isLoading}
                        />
                      </Col>
                    </Row>

                  </Col>
                </Row>
              </Col>
            </Row>
            <Col lgOffset={1} style={{ paddingTop: 10 }}>
              <div className='hcsaHide'>
                {this.renderPeriodTotals()}
              </div>
            </Col>
          </Grid>
        </Card>
      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  let memberData = (state.SubmitExpenseReducer.members || []).map((member) => {
    return { id: member, text: member }
  })
  let benefitData = (state.SubmitExpenseReducer.benefits || []).map((benefit) => {
    return { id: benefit, text: benefit }
  })
  return {
    hcsaExpenseData: state.SubmitExpenseReducer.hcsaExpenseData,
    expenseError: state.SubmitExpenseReducer.expenseError,
    isLoading: state.SubmitExpenseReducer.isLoading,
    claimObj: state.SubmitAClaimReducer.claimObj,
    memberSummary: state.memberSummaryReducer.memberSummary,
    members: memberData,
    benefits: benefitData,
    name: state.SubmitExpenseReducer.name,
    type: state.SubmitExpenseReducer.type,
    startPeriod: state.SubmitExpenseReducer.startDate,
    endPeriod: state.SubmitExpenseReducer.endDate,
    pageNum: state.SubmitExpenseReducer.pageNum,
    prevPeriodTotal: state.SubmitExpenseReducer.prevPeriodTotal || 0.00,
    currPeriodTotal: state.SubmitExpenseReducer.currPeriodTotal || 0.00
  }
}

const ConnectedhcsaFilter = connect(mapStateToProps, { fetchUnclaimedHCSAExpenses, setFilters, changePage }, null, { withRef: true })(injectIntl(hcsaFilter, { withRef: true }))

const styles = {
  ...CardStyles
}

export default withStyles(styles)(ConnectedhcsaFilter)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/hcsaFilter.js